import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '../ui/button'
import { useConsent } from '../../context/ConsentContext'
import { useLocalePath } from './LanguageRoute'
import CookiePreferencesDialog from './CookiePreferencesDialog'

export default function CookieBanner() {
  const { t } = useTranslation()
  const { isPending, acceptAll, acceptNecessary } = useConsent()
  const lp = useLocalePath()
  const [prefsOpen, setPrefsOpen] = useState(false)

  if (!isPending) return null

  return (
    <>
      <div
        role="dialog"
        aria-label={t('cookie.bannerAriaLabel')}
        className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gcg-border shadow-lg px-4 py-4 sm:px-6"
      >
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-6">
          <p className="text-sm text-gcg-text flex-1">
            {t('cookie.bannerText')}{' '}
            <Link
              to={lp('/cms/privacyverklaring')}
              className="underline hover:text-primary transition-colors"
            >
              {t('cookie.bannerPrivacyLink')}
            </Link>
          </p>
          <div className="flex items-center gap-2 shrink-0 flex-wrap">
            <Button
              variant="ghost"
              size="sm"
              className="text-neutral-600 hover:text-gcg-text text-xs"
              onClick={() => setPrefsOpen(true)}
            >
              {t('cookie.preferences')}
            </Button>
            <Button variant="secondary" size="sm" onClick={acceptNecessary}>
              {t('cookie.onlyNecessary')}
            </Button>
            <Button size="sm" onClick={acceptAll}>
              {t('cookie.acceptAll')}
            </Button>
          </div>
        </div>
      </div>

      <CookiePreferencesDialog open={prefsOpen} onClose={() => setPrefsOpen(false)} />
    </>
  )
}
